import React, { createContext, useState, useContext, useEffect } from 'react';
import { WORKER_URL, getAuthHeaders } from '../utils/api';

const MLContext = createContext();

export function MLProvider({ children }) {
  const [isMLConnected, setIsMLConnected] = useState(false);

  useEffect(() => {
    fetch(`${WORKER_URL}/api/user/me`, { headers: getAuthHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.id) setIsMLConnected(true); })
      .catch(() => {});
  }, []);

  return (
    <MLContext.Provider value={{ isMLConnected, setIsMLConnected }}>
      {children}
    </MLContext.Provider>
  );
}

export function useML() {
  return useContext(MLContext);
}
